import { render, staticRenderFns } from "./RecipientInfoBox.vue?vue&type=template&id=3b257b56&scoped=true"
import script from "./RecipientInfoBox.vue?vue&type=script&lang=ts"
export * from "./RecipientInfoBox.vue?vue&type=script&lang=ts"
import style0 from "./RecipientInfoBox.vue?vue&type=style&index=0&id=3b257b56&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b257b56",
  null
  
)

export default component.exports